import { useEffect } from 'react'

import {
  callDataSelector,
  clientRoleSelector,
  conversationSelector,
  hasSentMessageSelector,
  useStore,
} from '@liveHelper/models/store'

import { useLocalStorage } from '@core/hooks/useLocalStorage'

/** Persists last engaged conversation when the visitor engages. */
export function usePersistLastEngagedConversation() {
  const conversation = useStore(conversationSelector)
  const callData = useStore(callDataSelector)
  const clientRole = useStore(clientRoleSelector)
  const hasSentMessage = useStore(hasSentMessageSelector)
  const [_, setLastEngagedConversation] = useLocalStorage(
    'lastEngagedConversation',
  )

  useEffect(() => {
    if ((callData && clientRole === 'host') || hasSentMessage) {
      setLastEngagedConversation(conversation?.id)
    }
  }, [
    callData,
    clientRole,
    conversation,
    hasSentMessage,
    setLastEngagedConversation,
  ])
}
